import {BaseModel} from "../../base/models/base-model.model";
import {AdditionalModifyProductStateReason} from "../../shared/DTO/additionalModifyProductStateReason";
import {ListFile} from "../../shared/DTO/listFile";
import {ProductState} from "../../shared/DTO/productState";
import {ModifyProductStateReason} from "../../shared/DTO/modifyProductStateReason";

export class ModifyProductStateModel extends BaseModel {
  private _additionalReasons?: AdditionalModifyProductStateReason;
  private _files?: ListFile;
  private _newState: ProductState;
  /**
   * Note
   */
  private _note?: string;
  private _reason?: ModifyProductStateReason;
  private _reactivationDate?: string;

  constructor(additionalReasons?: AdditionalModifyProductStateReason, files?: ListFile, newState?: ProductState, note?: string, reason?: ModifyProductStateReason, reactivationDate?: string) {
    super();
    this._additionalReasons = additionalReasons;
    this._files = files;
    this._newState = newState;
    this._note = note;
    this._reason = reason;
    this._reactivationDate = reactivationDate;
  }

  get additionalReasons(): AdditionalModifyProductStateReason {
    return this._additionalReasons;
  }

  set additionalReasons(value: AdditionalModifyProductStateReason) {
    this._additionalReasons = value;
  }

  get files(): ListFile {
    return this._files;
  }

  set files(value: ListFile) {
    this._files = value;
  }

  get newState(): ProductState {
    return this._newState;
  }

  set newState(value: ProductState) {
    this._newState = value;
  }

  get note(): string {
    return this._note;
  }

  set note(value: string) {
    this._note = value;
  }

  get reason(): ModifyProductStateReason {
    return this._reason;
  }

  set reason(value: ModifyProductStateReason) {
    this._reason = value;
  }

  get reactivationDate(): string {
    return this._reactivationDate;
  }

  set reactivationDate(value: string) {
    this._reactivationDate = value;
  }
}
